import CrudUserData from 'components/crudUsers/CrudUserData'
import AssignCenterDynamicTable from 'components/genericCrud/AssignCenterDynamicTable'
import ListCrudTabContent from 'components/genericCrud/ListCrudTabContent'
import { CRUD_USER_DATA } from 'utils/RoutePath'

export const userConfig = {
	id: 'userCrud',
	key: 'cod_usu',
	descrip: 'nombre',
	searchMethod: 'get',
	category: 'C',
	translation: 'user_data',
	dataUrl: CRUD_USER_DATA,
	urlApi: 'abm_usuarios',
	component: ListCrudTabContent,
	tabsList: [
		{
			key: 'basic',
			title: 'CRUDS.general_use.basic_tab',
			tabComponent: CrudUserData
		},
		{
			key: 'profiles_tab',
			title: 'CRUDS.general_use.user_profiles',
			urlApi: 'abm_usuarios/perfiles',
			tabId: 'cod_usu',
			valueId: 'cod_grupo',
			tabComponent: AssignCenterDynamicTable
		}
	],
	tabsGroups: ['grilla', 'grilla.perfil'],
	tabsGroupsAlta: ['principal', 'grupo.perfil']
}
